import { render } from "./XPreferences.vue?vue&type=template&id=e5a4fc30&scoped=true"
import script from "./XPreferences.vue?vue&type=script&lang=js"
export * from "./XPreferences.vue?vue&type=script&lang=js"

import "./XPreferences.vue?vue&type=style&index=0&id=e5a4fc30&lang=less&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.33_webpack@5.93.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5a4fc30"]])

export default __exports__